import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/** Log and surface an API error consistently (never swallow silently). */
export function reportError(context, error, notify) {
  const detail = error?.response?.data?.detail;
  const message = typeof detail === 'string' ? detail : Array.isArray(detail) ? detail[0]?.msg : error?.message;
  // eslint-disable-next-line no-console
  console.error(`[Admin] ${context}:`, message || error);
  if (notify) notify(message);
  return message;
}

export const adminGet = (path, key, params = {}) =>
  axios.get(`${BACKEND_URL}${path}`, { params: { key, ...params } });

export const adminPut = (path, key, params = {}, body) =>
  axios.put(`${BACKEND_URL}${path}`, body, { params: { key, ...params } });

export const adminPost = (path, key, params = {}, body) =>
  axios.post(`${BACKEND_URL}${path}`, body, { params: { key, ...params } });

export const adminDelete = (path, key, params = {}) =>
  axios.delete(`${BACKEND_URL}${path}`, { params: { key, ...params } });

export const adminUpload = (method, path, key, formData) => {
  formData.append('admin_key', key);
  return axios({ method, url: `${BACKEND_URL}${path}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } });
};

export const formatDate = (value, withTime = false) => {
  if (!value) return '';
  const opts = { day: '2-digit', month: '2-digit', year: 'numeric' };
  if (withTime) Object.assign(opts, { hour: '2-digit', minute: '2-digit' });
  return new Date(value).toLocaleDateString('fr-FR', opts);
};

export const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4 } }
};

export const AGENCY_ID = 'artois.ptitservices';
